import * as XLSX from 'xlsx';
import * as R from "ramda";
import { DateTime } from "luxon";
import { UserRegistrationType } from "../features/managements/modules/users/UserRegistrationType";

export function convertCsvToExcelBuffer(csvString) {
  const arrayOfArrayCsv = csvString.split("\n").map((row) => {
    return row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
  })
  const stripedArrayOfArrayCsv = arrayOfArrayCsv.map(function (row) {
    return row.map(function (item) {
      return item.replace('\r', '')
        .replace('""', '')
        .replace(/^"(.+(?="$))"$/, '$1')
        .replace(/\\n/g, "\n");
    });
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(stripedArrayOfArrayCsv, { dense: true });
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Default');
  worksheet['!cols'] = fitToColumn(stripedArrayOfArrayCsv);

  function fitToColumn(arrayOfArray) {
    // get maximum character of each column
    return arrayOfArray[0].map((a, i) => ({
      wch: Math.max(...arrayOfArray.map(a2 => a2[i] ? a2[i].toString().length : 0))
    }));
  }

  const rawExcel = XLSX.write(workbook, {
    bookType: 'xlsx',
    bookSST: false,
    compression: true,
    type: 'buffer'
  })
  return rawExcel
}

export function debounce(fn, delaySecond = 2) {
  let timeoutID = null;

  return function _debounce() {
    clearTimeout(timeoutID);
    /* eslint-disable */
    const args = arguments;
    const that = this;

    timeoutID = setTimeout(function callback() {
      fn.apply(that, args);
    }, delaySecond * 1000);
  };
}

export function toCamelCaseObject(value) {
  if (value === null || typeof value === 'undefined') {
    return value
  }

  if (Array.isArray(value)) {
    return value.map(toCamelCaseObject)
  }

  if (typeof value !== 'object') {
    return value
  }

  return Object.keys(value)
    .map(snakeCase => {
      const camelCase = snakeCaseToCamelCase(snakeCase)

      return { snakeCase, camelCase }
    })
    .reduce((all, { snakeCase, camelCase }) => {
      const val = value[snakeCase]

      if (!Array.isArray(val) && typeof val !== 'object') {
        return { ...all, [camelCase]: val }
      }

      if (typeof val === 'object') {
        return { ...all, [camelCase]: toCamelCaseObject(val) }
      }

      return {
        ...all,
        [camelCase]: value.map(toCamelCaseObject)
      }
    }, {})
}

function snakeCaseToCamelCase(text) {
  return text.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  )
}

export function existValueAndEmptyString(text) {
  return text !== null && text !== undefined && text !== '' && text !== 'null'
}

export function existValue(text) {
  return text !== null && text !== undefined
}

export function getKeyByUrlPath(imageUrl) {
  const withholdingTaxKeyAlbum = imageUrl && imageUrl.length > 0
    ? imageUrl.map((imageUrl) => {
      const imageSplitPath = imageUrl.split("/")
      const imageLastArray = imageSplitPath[imageSplitPath.length - 1]

      const questionMark = '?'
      if (imageLastArray.indexOf(questionMark)) {
        const imageKeySplitPath = imageLastArray.split(questionMark)

        return imageKeySplitPath[0]
      } else {
        return imageLastArray
      }
    })
    : undefined

  return withholdingTaxKeyAlbum
}

export function getUniqArrayObject(arrayObject, key) {
  if (!arrayObject || arrayObject.length === 0) return []

  return R.pipe(
    R.map(R.path([key])), R.uniq
  )(arrayObject)
}

export function isValidEmail(email) {
  const emailRegex = /\S+@\S+\.\S+/;

  return emailRegex.test(email);
}

export function isValidPhone(phoneNumber) {
  const phoneRegex = /^0([2-9]\d{1}|[34679]\d{2})\d{6,7}$/;

  phoneNumber = phoneNumber.replace(/-/g, ''); // Remove hyphens from input
  if (!/^\d+$/.test(phoneNumber)) { // Check if input contains only digits
    return false;
  }

  if (phoneNumber.length < 9 || phoneNumber.length > 10) {
    return false;
  }

  return phoneRegex.test(phoneNumber);
}

export function checkExistEveryValueInObject(object) {
  return Object.values(object).every((value) =>
    existValueAndEmptyString(value)
  );
}

export function convertCamelToSnake(obj) {
  const snakeCaseObj = {};
  for (const key in obj) {
    const snakeCaseKey = camelToSnake(key);
    snakeCaseObj[snakeCaseKey] = obj[key];
  }
  return snakeCaseObj;
}

function camelToSnake(camelCaseStr) {
  return camelCaseStr.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`).toLowerCase();
}

export function filterNonNull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
}

export function checkExistSomeValueInObject(object) {
  return Object.values(object).some((value) =>
    existValueAndEmptyString(value)
  );
}

export function convertToCSV(objArray) {
  let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  let str = '';
  for (let i = 0; i < array.length; i++) {
    let line = '';
    for (let index in array[i]) {
      if (line != '') line += ','
      line += array[i][index];
    }
    str += line + '\r\n';
  }
  return str;
}

export function formatTotalPagination(dataLength, currentPage, total, limit) {
  // Return message if no data is present
  if (!total || total === 0) return "ไม่พบข้อมูล";

  // Format total with commas for readability
  total = total.toLocaleString();

  // Check if it's the last page
  const isLastPage = limit > dataLength;

  // Convert currentPage to a number or set to 1 if falsy
  currentPage = +currentPage || 1;

  // Calculate and format start and end values based on pagination
  const end = (isLastPage ? total : currentPage * limit).toLocaleString();
  const start = (
    (isLastPage ? limit * currentPage - limit : end - limit) + 1
  ).toLocaleString();

  // Return formatted data range and total
  return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
}

export function stringsToDates(dateRange) {
  // Validate date is Array
  if (
    !Array.isArray(dateRange)
  ) {
    return []
  }

  // Convert date in array
  return dateRange.map(date => DateTime.fromISO(date));
}

export function datesToStrings(dateRange) {
  // Validate date is Array
  if (
    !Array.isArray(dateRange)
  ) {
    return []
  }

  // Convert date in array
  return dateRange.map(date => DateTime.fromISO(date).toISO());
}

export function isValidReceiptUserName(name) {
  const thaiEnglishRegex = /^[ก-๙a-zA-Z\s\.,\d()]+$/;

  if (name.match(thaiEnglishRegex)) {
    return {
      isValid: true,
      error: ''
    };
  } else {
    return {
      isValid: false,
      error: 'ไม่สามารถกดส่งใบเสร็จได้เนื่องจากชื่อใบเสร็จไม่ถูกต้อง'
    };
  }
}

export function resolveRegistrationTypeName(registrationType) {
  switch (registrationType) {
    case UserRegistrationType.MOBILE_NUMBER: {
      return "เบอร์โทรศัพท์";
    }

    case UserRegistrationType.EMAIL: {
      return "อีเมล";
    }

    case UserRegistrationType.APPLE: {
      return "Sign in with Apple";
    }

    case UserRegistrationType.FACEBOOK: {
      return "Log in with Facebook";
    }

    default: {
      return "-";
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/util.js